export const SET_SWITCH_SCHOOL = "SET_SWITCH_SCHOOL";

export const switchSchool = (data) => (dispatch) => {
  dispatch({
    type: SET_SWITCH_SCHOOL,
    payload: data,
  });
};
